import { render } from "./TheRecommend.vue?vue&type=template&id=006bda34&scoped=true&ts=true"
import script from "./TheRecommend.vue?vue&type=script&lang=ts"
export * from "./TheRecommend.vue?vue&type=script&lang=ts"

import "./TheRecommend.vue?vue&type=style&index=0&id=006bda34&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006bda34"]])

export default __exports__